import _classCallCheck from "/Users/cheisler/workspace/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/cheisler/workspace/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/cheisler/workspace/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/cheisler/workspace/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/Users/cheisler/workspace/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/cheisler/workspace/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { EventEmitter } from "events";
import { TransportError } from "../exceptions";
/**
 * Transaction.
 * @remarks
 * SIP is a transactional protocol: interactions between components take
 * place in a series of independent message exchanges.  Specifically, a
 * SIP transaction consists of a single request and any responses to
 * that request, which include zero or more provisional responses and
 * one or more final responses.  In the case of a transaction where the
 * request was an INVITE (known as an INVITE transaction), the
 * transaction also includes the ACK only if the final response was not
 * a 2xx response.  If the response was a 2xx, the ACK is not considered
 * part of the transaction.
 * https://tools.ietf.org/html/rfc3261#section-17
 * @public
 */

export var Transaction = /*#__PURE__*/function (_EventEmitter) {
  _inherits(Transaction, _EventEmitter);

  function Transaction(_transport, _user, _id, _state, loggerCategory) {
    var _this;

    _classCallCheck(this, Transaction);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Transaction).call(this));
    _this._transport = _transport;
    _this._user = _user;
    _this._id = _id;
    _this._state = _state;
    _this.logger = _user.loggerFactory.getLogger(loggerCategory, _id);

    _this.logger.debug("Constructing ".concat(_this.typeToString(), " with id ").concat(_this.id, "."));

    return _this;
  }
  /**
   * Destructor.
   * Once the transaction is in the "terminated" state, it is destroyed
   * immediately and there is no need to call `dispose`. However, if a
   * transaction needs to be ended prematurely, the transaction user may
   * do so by calling this method (for example, perhaps the UA is shutting down).
   * No state transition will occur upon calling this method, all outstanding
   * transmission timers will be cancelled, and use of the transaction after
   * calling `dispose` is undefined.
   */


  _createClass(Transaction, [{
    key: "dispose",
    value: function dispose() {
      this.logger.debug("Destroyed ".concat(this.typeToString(), " with id ").concat(this.id, "."));
    }
    /** Transaction id. */

  }, {
    key: "on",
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value: function on(name, callback) {
      return _get(_getPrototypeOf(Transaction.prototype), "on", this).call(this, name, callback);
    }
  }, {
    key: "logTransportError",
    value: function logTransportError(error, message) {
      this.logger.error(error.message);
      this.logger.error("Transport error occurred in ".concat(this.typeToString(), " with id ").concat(this.id, "."));
      this.logger.error(message);
    }
    /**
     * Pass message to transport for transmission. If transport fails,
     * the transaction user is notified by callback to onTransportError().
     * @returns
     * Rejects with `TransportError` if transport fails.
     */

  }, {
    key: "send",
    value: function send(message) {
      var _this2 = this;

      return this.transport.send(message).catch(function (error) {
        // If the transport rejects, it SHOULD reject with a TransportError.
        // But the transport may be external code, so we are careful
        // make sure we convert it to a TransportError if need be.
        if (error instanceof TransportError) {
          _this2.onTransportError(error);

          throw error;
        }

        var transportError;

        if (error && typeof error.message === "string") {
          transportError = new TransportError(error.message);
        } else {
          transportError = new TransportError();
        }

        _this2.onTransportError(transportError);

        throw transportError;
      });
    }
  }, {
    key: "setState",
    value: function setState(state) {
      this.logger.debug("State change to \"".concat(state, "\" on ").concat(this.typeToString(), " with id ").concat(this.id, "."));
      this._state = state;

      if (this._user.onStateChange) {
        this._user.onStateChange(state);
      }

      this.emit("stateChanged");
    }
  }, {
    key: "typeToString",
    value: function typeToString() {
      return "UnknownType";
    }
  }, {
    key: "id",
    get: function get() {
      return this._id;
    }
    /** Transaction kind. Deprecated. */

  }, {
    key: "kind",
    get: function get() {
      throw new Error("Invalid kind.");
    }
    /** Transaction state. */

  }, {
    key: "state",
    get: function get() {
      return this._state;
    }
    /** Transaction transport. */

  }, {
    key: "transport",
    get: function get() {
      return this._transport;
    }
  }]);

  return Transaction;
}(EventEmitter);